import React from 'react';
import candle from '../../images/candle.png';
import flame from '../../images/flame.svg';
import glow from '../../images/glow.svg';

const Candle = () => (
	<div className="candle">
		<img className="glow" src={glow} alt="candle glow" />
		<img className="base" src={candle} alt="candle base" />
		<img className="flame" src={flame} alt="candle flame" />
	</div>
);

export default Candle;